<div class="header-tab" [ngClass]="{'selected': selected}" (click)="selectTabbed()">
  <sc-flex fitHeight>
    <div class="label">{{structure.title}}</div>
    @if (selected) {
      <sc-content-spacer></sc-content-spacer>
    }
    @if (selected) {
      <div class="close-action"><sc-icon iconClass="fa-times close-btn" (click)="closeTabbed()"></sc-icon></div>
    }
  </sc-flex>
</div>
